/**
 * @typedef {{
 *   id: string,
 *   title: string,
 * }} NavProject
 */

/** Mock DO Code projects for the secondary nav Project List. */
/** @type {NavProject[]} */
const PROJECTS = [
  { id: 'project-1', title: 'Customer Portal Redesign' },
  { id: 'project-2', title: 'Invoice OCR Pipeline' },
  { id: 'project-3', title: 'Internal Admin Console' },
  { id: 'project-4', title: 'Sales Analytics Dashboard' },
  { id: 'project-5', title: 'Onboarding Workflow App' },
]

export default PROJECTS
